// * Blog

// * NCC-578 | Remove links and hover on images
var $n = jQuery(".blog-image__image").parent("a");
if ($n) {
  $n.removeAttr("href");
  $n.addClass("removeAfterHover");
}